import React from "react";
import LeftBox from "./LeftBox";
import RightBox from "./RightBox";

const CategoryComponent = ({
  className,
  leftBoxProps,
  rightBoxProps,
  show,
}) => (
  <>
    <div className={`category-container ${className}`}>
      <LeftBox {...leftBoxProps} show={show} />
      <RightBox {...rightBoxProps} />
    </div>
  </>
);

export default CategoryComponent;
